import React from "react";
import { User } from "../../Model/User";
import MtiButton from "../Buttons/MtiButton";
import CommandPanel from "../CommandPanel/CommandPanel";
import "./GenerateOtpPanel.css";

type Props = {
  user: User;
  backBtn: () => void;
};

export default function GenerateOtpPanel({ user, backBtn }: Props) {
  const onCopy = () => {
    if (user.userOtp != null) {
      navigator.clipboard.writeText(user.userOtp);
    }
  };

  return (
    <CommandPanel>
      <CommandPanel.UsersInfoHeader users={[user]} />
      <CommandPanel.BackArrowHeader
        title="Request One Time Password"
        onBackArrowClick={backBtn}
      />
      <CommandPanel.VerticalContent>
        <div className="generate-otp-container">
          <span className="generate-otp-username-label">Username</span>
          <span className="generate-otp-email-label">Email</span>
          <span className="generate-otp-otp-label">Generated OTP</span>
          <span className="generate-otp-valid-label">Valid Till</span>
          <span className="generate-otp-username-field">{user.userName}</span>
          <span className="generate-otp-email-field">{user.userEmail}</span>
          <span className="generate-otp-otp-field">{user.userOtp}</span>
          <span className="generate-otp-valid-field">{user.otpExpiredAt}</span>
          <div className="generate-otp-copy-button">
            <MtiButton
              variant="primary"
              size="medium"
              onClick={onCopy}
              disabled={user.userOtp == null}
              style={{ minWidth: "96px" }}
            >
              Copy
            </MtiButton>
          </div>
        </div>
      </CommandPanel.VerticalContent>
    </CommandPanel>
  );
}
